import React from 'react';
import {connect} from 'react-redux';
import OpeningTimesFooter from '../shared/openingTimes/openingTimesFooter';
import AddressFooter from '../shared/address/AddressFooter';

const Footer = props => (
   <div className="footer-wrapper">
      <div className="footer">
         <div className="container">
            <div className="row">
               <div className="col-12 col-xl-5 col-md-5 col-sm-6">
                  <AddressFooter
                     firmData={props.firmData}
                     openingTimesCount="hidden"
                     hauptsitz={true}
                  />
               </div>
               <div className="col-12 col-xl-5 col-md-5 col-sm-6">
                  {props.firmData ?
                     <div className="contact-cards">
                        <div>
                           <h3>Öffnungszeiten</h3>
                        </div>
                        <OpeningTimesFooter data={props.firmData} vendorNo={0}/>
                     </div>
                     :
                     <div>
                     </div>
                  }
               </div>
               {props.firmData ?
                  <div className="col-2 col-xl-2 d-none d-md-block">
                     <h3>Rechtliches</h3>
                     <div>
                        <a target="_blank" href={'https://automeister.de/nutzungsbedingungen'}> Nutzungsbedingungen </a>
                     </div>
                     <div>
                        <a target="_blank"
                           href={'https://automeister.de/datenschutzerklaerung'}> Datenschutzerklärung </a>
                     </div>
                     <div>
                        <a target="_blank" href={'https://automeister.de/impressum'}> Impressum </a>
                     </div>
                  </div>
                  :
                  <div className="col-2 col-xl-2 d-none d-md-block">
                  </div>
               }
            </div>
         </div>
      </div>
   </div>
);

const mapStateToProps = state => ({
   loggedIn: state.loggedIn,
   firmData: state.firmData
});
export default connect(mapStateToProps)(Footer);
